/*!
 * egt.content.page — renders one piece of API-published content (spec 35).
 *
 * Attributes (all strings — a null attribute drops the node):
 *   kind     episode | journal_entry | page | podcasts_index | podcast_show | countdown
 *   data     JSON: { payload, item, extra } prepared by app/helpers/egt.content.render.js
 *   banner   JSON or "" : { tone, text } — the logged-in "Unpublished / Scheduled" strip
 *
 * The per-kind views live in app/helpers/egt.content.views.js so later work
 * packages (podcast pages, The Making) replace a view without touching routing.
 */
var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.content.page",
  title: "EGT Content Page",
  description: "Renders API-published content (episodes, journal entries, pages, countdowns).",
  supportServer: true
});

var views = require("../helpers/egt.content.views.js");

function parse(text, fallback) {
  try { return text ? JSON.parse(text) : fallback; } catch (e) { return fallback; }
}

exports.render = async function render(options) {
  options = options || {};
  var data = parse(options.data, {});
  var banner = parse(options.banner, null);
  return views.render(String(options.kind || ""), data, banner);
};
